import bbox from '@turf/bbox';
import { debounce } from 'throttle-debounce';

import {
  SEARCH_MAX_RESULTS, WATERSHED_LAYER, WATERSHED_LAYER_SEARCH_FIELDS,
  SEARCH_MIN_STRING_LENGTH, WATERSHED_LAYER_NAME_FIELD,
} from '@/settings';

export default {
  name: 'SearchBox',

  props: {
    selectedWatershed: Object,
    wfsServerUrl: String,
  },

  data() {
    return {
      q: '',

      // can be 'clear', 'finished' or 'loading',
      state: 'clear',

      // results of a search
      features: [],

      // Attributes of a feature used for search
      name_attrs: WATERSHED_LAYER_SEARCH_FIELDS,

      // prevents a search from bein triggered when a watershed is selected
      searchTrigger: true,
    };
  },

  watch: {
    q: debounce(250, function qDebounced() {
      if (!this.searchTrigger || this.q.length < SEARCH_MIN_STRING_LENGTH) {
        if (!this.searchTrigger) {
          this.state = 'finished';
        } else {
          this.state = 'clear';
        }

        this.features = [];
        this.searchTrigger = true;

        return;
      }

      this.state = 'loading';

      const url = new URL(this.wfsServerUrl);
      const searchParams = new URLSearchParams({
        service: 'wfs',
        version: '2.0.0',
        request: 'GetFeature',
        typeNames: WATERSHED_LAYER,
        cql_filter: WATERSHED_LAYER_SEARCH_FIELDS.map(f => `${f} ILIKE '%${this.q}%'`).join(' OR '),
        outputFormat: 'application/json',
        count: SEARCH_MAX_RESULTS,
      });

      url.search = searchParams.toString();

      fetch(url)
        .then(res => res.json())
        .then((data) => {
          this.features = data.features;
          this.state = 'finished';

          if (data.features.length > 0) {
            this.$emit('resultExtent', bbox(data));
          }
        });
    }),

    selectedWatershed() {
      if (this.selectedWatershed !== null) {
        this.searchTrigger = false;
        this.q = this.selectedWatershed.properties[WATERSHED_LAYER_NAME_FIELD];
      }
    },
  },

  methods: {
    clearSearch() {
      this.featureSelected(null);
    },

    featureSelected(feature) {
      this.q = '';
      this.$emit('update:selectedWatershed', feature);
    },
  },
};
